import * as z from "zod";
import { InlineLockAttrsSchema } from "./lock-types-schema";

/**
 * StepSelect node - a selection-based step that displays a dropdown.
 * Used inside sections for step types with inputType: "select".
 */
const StepSelectNodeSchema_ = z.object({
  type: z.literal("stepSelect"),
  instanceId: z.string(),
  /** Links to StepTypeConfig.value (e.g., "use_template") */
  stepTypeValue: z.string(),
  selectionKey: z.string().optional(),
  selectionLabel: z.string().optional(),
  itemKey: z.string().optional(),
  itemLabel: z.string().optional(),
  lock: InlineLockAttrsSchema.optional(),
});

/** Base type from schema inference (no index signature). Exported for use with Omit. */
export type StepSelectNodeBase = z.infer<typeof StepSelectNodeSchema_>;

/** Full type with index signature for FlowContentNode compatibility */
export type StepSelectNode = StepSelectNodeBase & { [key: string]: unknown };

/** Attrs type for tiptap (Omit done on base type before index signature) */
export type StepSelectNodeAttrs = Omit<StepSelectNodeBase, "type">;

export const StepSelectNodeSchema: z.ZodType<StepSelectNode> =
  StepSelectNodeSchema_;

/**
 * Type guard for stepSelect nodes.
 */
export function isStepSelectNode(node: unknown): node is StepSelectNode {
  return (
    typeof node === "object" &&
    node !== null &&
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    (node as Record<string, unknown>).type === "stepSelect"
  );
}
